import React from 'react';

import { useLocation } from 'react-router-dom';
import { useQueryParams } from '../../../../providers/QueryParamsProvider';

export const useURLSearchHandler = () => {
  const { pathname } = useLocation();
  const { query, replace } = useQueryParams();

  return React.useCallback(
    (value: string) => {
      const { search, pageRequested, searchAfter, page, ...rest } = query;

      if (value) {
        replace(pathname, { query: { ...rest, search: value } });
      } else {
        replace(pathname, { query: { ...rest } });
      }
    },
    [pathname, query, replace]
  );
};
